// Runtime configuration derived from Vite env vars.
// NB: `import.meta.env.*` is inlined at build time — no secrets here (public client only).

/** API base, including the `/api/v1` prefix. Trailing slash stripped for safe joins. */
export const API_BASE: string = (import.meta.env.VITE_API_BASE ?? "/api/v1").replace(/\/+$/, "");

/** OAuth2 PKCE client id for the web dashboard. */
export const OAUTH_CLIENT_ID: string = import.meta.env.VITE_OAUTH_CLIENT_ID ?? "ahcut-dashboard";

/** Marketing site origin (download page, legal). */
export const MARKETING_BASE: string = (import.meta.env.VITE_MARKETING_BASE ?? "https://ahcut.com").replace(/\/+$/, "");

/** Where the OAuth provider redirects back to after login. */
export function redirectUri(): string {
  return `${window.location.origin}/callback`;
}
